import {Component, effect, inject, input, signal} from '@angular/core';
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {
  AnimalDetailsContainerComponent
} from "src/app/presentation/main-view/information-center/animals/animal-details/animal-details-container/animal-details-container.component";
import {Animal} from 'src/app/infrastructure/moovement-api/models/asset';
import {
  ProfilePictureEditorComponent
} from "src/app/presentation/main-view/information-center/animals/profile-picture-editor/profile-picture-editor.component";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Location} from '@angular/common';
import {DataSynchronisationService} from 'src/app/infrastructure/data-synchronisation.service';
import {InternalNotificationsStore} from 'src/app/infrastructure/internal-notifications/internal-notifications.store';
import {ScheduledUpdates} from 'src/app/infrastructure/scheduled-updates/scheduled-updates';
import {randomUuid} from 'src/app/domain/util/uuid/uuid';

@Component({
  selector: 'app-set-animal-profile-picture',
  standalone: true,
  imports: [
    AnimalDetailsContainerComponent,
    ProfilePictureEditorComponent,
    GenericButtonComponent
],
  templateUrl: './set-animal-profile-picture.component.html',
  styleUrl: './set-animal-profile-picture.component.css'
})
export class SetAnimalProfilePictureComponent {

  id = input.required<string>();

  animal = signal<Animal | undefined>(undefined);
  updated = signal(false);
  newImageUrl = signal<string | undefined>(undefined);

  private animalStore = inject(AnimalsStore);
  private dataSynchronisationService = inject(DataSynchronisationService);
  private internalNotificationsStore = inject(InternalNotificationsStore);
  private location = inject(Location);

  constructor() {
    effect(() => {
      const id = this.id();
      if (!id) return;

      const animal = this.animalStore.entityMap()[id];
      this.animal.set(animal);
    });
  }

  setProfilePictureUrl(url?: string) {
    this.updated.set(true);
    this.newImageUrl.set(url);
  }

  async saveProfilePicture() {
    const animal = this.animal();
    if (!animal) return;

    const name = animal.visualTag ? animal.visualTag : animal.id;

    const updates: ScheduledUpdates = {
      id: randomUuid(),
      updates: [
        {
          type: "setProfilePicture",
          data: {
            animalId: this.id(),
            profilePictureUrl: this.newImageUrl(),
          }
        }
      ],
      successMessage: `Successfully updated profile picture for '${name}'.`,
      scheduledMessage: `Profile picture for '${name}' will be updated when you're online again.`,
      failureMessage: `Unable to set profile picture for '${name}'.`
    }
    await this.dataSynchronisationService.scheduleUpdates(updates);
    this.location.back();
  }
}
